/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RegisterUserSuccessAliases {
  BUTTON_CONFIRMATION = 'button-confirmation',
  IMAGE_SUCCESS = 'image-success',
  LAYOUT_NEW_USER_SUCCESS = 'layout-new-user-success',
  MODAL_0 = 'modal-0',
  PANEL_0 = 'panel-0',
  PANEL_CONFIRMATION = 'panel-confirmation',
  PANEL_IMAGE = 'panel-image',
  PANEL_SUBTITLE = 'panel-subtitle',
  PANEL_TITLE = 'panel-title',
  TEXT_0 = 'text-0',
  TEXT_SUBTITLE = 'text-subtitle',
  TEXT_TITLE = 'text-title',
}
export { RegisterUserSuccessAliases };
